export default __webpack_public_path__ + "static/media/308 04222022.31516fe7.jpg";